module.exports = __webpack_public_path__ + "static/media/gl.c394644d.svg";